import { Button, ButtonProps, Theme } from '@mui/material';
import { FC, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { important } from 'common-types';

const CodeRepositoryButton: FC<
  React.PropsWithChildren<CodeRepositoryButtonProps>
> = ({ selected, error, onRepoSelect, repoName, ...buttonProps }) => {
  const { classes, cx } = useStyles();
  const onClick = useCallback(() => {
    onRepoSelect(repoName);
  }, [onRepoSelect, repoName]);
  return (
    <Button
      color='inherit'
      variant='contained'
      className={cx(
        classes.codeRepositoryButton,
        { [classes.selected]: selected },
        { [classes.error]: error },
      )}
      onClick={onClick}
      {...buttonProps}
    />
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  codeRepositoryButton: {
    minHeight: '60px',
    background: important(
      `${theme.palette.onboarding.codeRepoButton.background}`,
    ),
    textTransform: important('none'),
    boxShadow: important(`0px 2px 10px rgba(0, 0, 0, 0.15)`),
    '&:hover': {
      boxShadow: important(`0px 2px 10px rgba(0, 0, 0, 0.35)`),
    },
    justifyContent: important('flex-start'),
  },
  selected: {
    border: important(`1px solid ${theme.palette.primary.main}`),
    background: important(theme.palette.onboarding.codeRepoButton.selected),
  },
  error: {
    backgroundColor: important('rgba(250, 20, 20, 0.05)'),
    '&:hover': {
      background: important(`${'rgba(250, 20, 20, 0.05)'}`),
    },
    border: important(`1px solid ${theme.palette.error.main}`),
  },
}));

interface CodeRepositoryButtonProps extends ButtonProps {
  selected: boolean;
  error: boolean;
  repoName: string;
  onRepoSelect: (repo: string) => void;
}

export default CodeRepositoryButton;
